import React, { useState } from "react";
import apiClient from "../components/apiClient";

const ForgotPassword = () => {
  const [identifier, setIdentifier] = useState(""); // email or username
  const [newPassword, setNewPassword] = useState("");
  const [email, setEmail] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleReset = async (e) => {
    e.preventDefault(); // Prevent form refresh
    setMessage("");
    setError("");

    if (!email) {
      setError("Please enter your email.");
      return;
    }

    try {
      const requestBody = { email };
      console.log("Sending email reset request with body:", requestBody);

      const response = await apiClient.post("/user/sendlinkreset", requestBody);
      //     {
      //     method: "POST",
      //     headers: { "Content-Type": "application/json" },
      //     body: JSON.stringify(requestBody),
      //   });

    //   const result = await response.json();
      console.log("Response from /sendlinkreset:", response.data);

      setMessage(
        "Email link reset password has been sent successfully to your email. Please check your inbox."
      );
      setEmail("");
    } catch (err) {
      console.error(
        "Error while sending reset email:",
        err.response?.data || err.message
      );
      setError(
        err.response?.data?.message || "Server error. Please try again later."
      );
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="bg-white w-full max-w-lg rounded-lg shadow-xl p-8 space-y-6">
        <h1 className="text-3xl font-bold text-center text-gray-900">
          Reset Password
        </h1>

        {message && (
          <p className="text-green-600 text-center text-sm">{message}</p>
        )}
        {error && <p className="text-red-500 text-center text-sm">{error}</p>}
        <form onSubmit={handleReset} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Please enter your email
            </label>
            <input
              type="email"
              value={email}
              title="Format should be email address"
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-md bg-gray-200 text-black placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-black"
              placeholder="you@example.com or username"
            />
          </div>

          <button
            type="submit"
            className="w-full py-3 bg-black text-white text-lg font-semibold rounded-md hover:bg-gray-800 transition-all duration-300"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
